<template>
  <div class="content">
    <div class="box">
      <p class="chinese-name">信息资讯</p>
      <p class="english-name">INFOMATION</p>
      <div class="swiper-content">
        <a-carousel
          :dots="false"
          ref="swiper"
        >
          <div 
            class="swiper-box" 
            v-for="item in list"
            :key="item.contentLogo"
            @click="goDetail(item.contentCode)"
            >
            <img :src="item.contentLogo">
          </div>
        </a-carousel>
        <div class="arrow">
          <p @click="choose(true)"><img src="../../../assets/images/icon_carousel_left_white.png"></p>
          <p @click="choose(false)"><img src="../../../assets/images/icon_carousel_right_white.png"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getInfo,
  getInfoetail
} from '@/api/translation.js'
import {
  getFileDetails
} from '@/api/file.js'
export default {
  name: 'information-consulting',
  data () {
    return {
      list: []
    }
  },
  created () {
    this._getInfo()
  },
  methods: {
    goDetail (contentCode) {
      const name = this.list.find(item => item.key === this.target).name
      this.pushRouter(`/guide?contentCode=${contentCode}&linkname=翻译服务/信息资讯/详情`)
    },
    choose (isprev) {
      if (isprev) {
        this.$refs && this.$refs.swiper.prev()
      } else {
        this.$refs && this.$refs.swiper.next()
      }
    },
    _getInfo () {
      getInfo().then(async res => {
        this.list = this._.get(res, 'data.records', [])
      })
    }
  }
}
</script>

<style scoped lang='less'>
p {
  margin: 0;
  padding: 0;
}
.content {
  width: 100%;
  position: relative;
  margin-top: 20px;
  cursor: pointer;
}
.box {
  width: 1140px;
  height: 600px;
  position: relative;
  margin: auto;
  // left: 50%;
  // transform: translateX(-50%);
  background: rgba(255, 255, 255, 1);
}
.chinese-name {
  font-size: 28px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #000000;
  position: absolute;
  left: 50%;
  top: 40px;
  transform: translateX(-50%);
  z-index: 999;
}
.english-name {
  font-size: 80px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #FAF5F5;
  position: relative;
}
.swiper-content {
  height: 480px;
  width: 1140px;
  position: relative;
  .swiper-box {
    background: rgba(117, 117, 117, 1);
    text-align: center;
    img {
      display: inline-block;
      width: 867px;
      height: 480px;
    }
  }
}
.arrow {
  cursor: pointer;
  p {
    position: absolute;
    width: 20px;
    height: 34px;
    top: 217px;
    img {
      width: 20px;
      height: 34px;
    }
  }
  p:first-of-type {
    left: 19px;
  }
  p:last-of-type {
    right: 18px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/translationService/siderContent-03.vue